import React from 'react';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import { LocalizationProvider, renderTimeViewClock } from '@mui/x-date-pickers';
import { TimePicker as MuiTimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { ThemeProvider } from '@mui/material/styles';

import './DatePickers.scss';
import { CustomActions } from './DateTimePicker';
import newTheme from '../../style/muiTheme';
import { getColorsForColorTheme } from '../../utils/colorTheme';

export default function TimePicker({value, className, showNowButton, ...props}) {
  const theme = React.useMemo(() => {
    if (!className?.includes('invalid-control-background')) {
      return newTheme(getColorsForColorTheme().mainColor);
    }
    const ret = cloneDeep(newTheme(getColorsForColorTheme().mainColor));
    ret.components.MuiTextField.styleOverrides.root.backgroundColor = 'rgba(218, 84, 125, 0.1)';
    return ret;
  }, [className]);

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="en">
        <MuiTimePicker
          // viewRenderers={{
          //   hours: renderTimeViewClock,
          //   minutes: renderTimeViewClock,
          //   seconds: renderTimeViewClock,
          // }}
          value={value || null}
          placeholder="hh:mm:ss a"
          formatDensity="spacious"
          slots={{
            actionBar: showNowButton ? CustomActions : undefined,
          }}
          slotProps={{
            field: { clearable: true },
          }}
          {...props}
        />
      </LocalizationProvider>
    </ThemeProvider>
  );
}

TimePicker.propTypes = {
  value: PropTypes.any,
  className: PropTypes.string,
  showNowButton: PropTypes.bool,
  onChange: PropTypes.func,
};